// Status types used for shifts and routes
export const RouteStatus = Object.freeze({
  COMPLETED: 'completed',
  ONGOING: 'ongoing',
  NO_ROUTES: 'no_routes',
  UNKNOWN: 'unknown',
  UPCOMING: 'upcoming',
  ALL: 'all'
});
